export default __webpack_public_path__ + "static/media/project-manager-art.de2ccfa5.png";